import { render, staticRenderFns } from "./EntityItem.vue?vue&type=template&id=28b2f744&"
import script from "./EntityItem.vue?vue&type=script&lang=ts&"
export * from "./EntityItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports